<template>
  <vs-row vs-type="block" vs-w="12" id="targetsPage">
    <vs-popup class="holamundo" title="Hedef Sil" :active.sync="deletePopupActive" v-esc="escape">
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Hedefi Silmek İstediğinize Eminmisiniz ? </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="deletePopupActive = false;deletedId = null">Vazgeç</vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
          @click="deleteTarget(deletedId)">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <target-reviewer ref="targetReviewer" :target="selectedTarget" @close="selectedTarget = {}" @show-detail="openTargetDetails" />

    <!-- HEDEF KANIT VE DETAY RAPORU MODAL (FULLSCREEN & HIGH PERFORMANCE) -->
    <vs-popup class="target-details-popup" title="📊 Hedef Kanıt Raporu (Sipariş Dökümü)" :active.sync="targetDetailPopupActive">
      <div v-if="targetDetailLoading" class="p-5 text-center my-auto">
        <vs-icon icon="sync" class="spin-icon" size="large" color="primary"></vs-icon>
        <p class="mt-2 weight-600 text-secondary">Sipariş verileri sorgulanıyor...</p>
      </div>
      <div v-else class="target-details-container">
        <!-- ÖZET VE FİLTRELEME BARI -->
        <div class="mb-3 p-3 bg-white rounded sale-box-shadow" style="border-radius:12px; flex-shrink:0;">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div>
              <h4 class="m-0 font-bold text-primary" style="font-size:18px;">{{ targetDetailTitle }}</h4>
              <small class="text-muted">Bu kaleme ait tüm satış döküm hareketleri (0 TL ikramlar hedefe eklenmez)</small>
            </div>
            <div class="d-flex gap-2">
              <span class="badge badge-success p-2 font-bold" style="background:#28c76f; color:#fff; border-radius:8px; font-size:13px; padding:8px 14px !important;">
                ✓ Toplam Katkı: {{ targetDetailTotalQty }} Adet
              </span>
              <span class="badge badge-info p-2 font-bold ml-2" style="background:#7367f0; color:#fff; border-radius:8px; font-size:13px; padding:8px 14px !important;">
                💰 Toplam Tutar: {{ $toCurrency(targetDetailTotalAmount) }}
              </span>
              <span class="badge badge-secondary p-2 font-bold ml-2" style="background:#6e6b7b; color:#fff; border-radius:8px; font-size:13px; padding:8px 14px !important;">
                📋 Toplam Kayıt: {{ filteredTargetDetailList.length }} Fiş
              </span>
            </div>
          </div>

          <!-- ARAMA VE SEKMELER -->
          <div class="row align-items-center mt-2">
            <div class="col-md-4 mb-1">
              <input type="text" class="form-control form-control-sm w-full p-2 border rounded" placeholder="🔍 Fiş No, Ürün veya Personel Ara..." v-model="targetDetailSearchText" style="border:1px solid #ddd; border-radius:8px; font-size:13px;" />
            </div>
            <div class="col-md-3 mb-1">
              <v-select class="w-full text-small" placeholder="Sipariş Türü" v-model="targetDetailOrderSourceType"
                        :options="['Tüm Türler', 'Şube', 'Mobil', 'Getir', 'Yemeksepeti', 'Trendyol']" :clearable="false" style="font-size: 12px; border-radius:8px;" />
            </div>
            <div class="col-md-5 mb-1 d-flex justify-content-end align-items-center">
              <div class="btn-group btn-group-toggle" style="display:flex; border-radius:8px; overflow:hidden; border:1px solid #ddd;">
                <button type="button" class="btn btn-sm px-3 py-1" 
                  :style="targetDetailFilterType === 'all' ? 'background: #7367f0; color: white !important; font-size:12px; cursor:pointer; border:none;' : 'background: #f8f9fa; color: #495057 !important; font-size:12px; cursor:pointer; border:none;'" 
                  @click="targetDetailFilterType = 'all'">Tüm Kayıtlar</button>
                <button type="button" class="btn btn-sm px-3 py-1" 
                  :style="targetDetailFilterType === 'valid' ? 'background: #28c76f; color: white !important; font-size:12px; cursor:pointer; border:none; border-left: 1px solid #ddd;' : 'background: #f8f9fa; color: #495057 !important; font-size:12px; cursor:pointer; border:none; border-left: 1px solid #ddd;'" 
                  @click="targetDetailFilterType = 'valid'">✓ Hedefe Dahil</button>
                <button type="button" class="btn btn-sm px-3 py-1" 
                  :style="targetDetailFilterType === 'ikram' ? 'background: #ea5455; color: white !important; font-size:12px; cursor:pointer; border:none; border-left: 1px solid #ddd;' : 'background: #f8f9fa; color: #495057 !important; font-size:12px; cursor:pointer; border:none; border-left: 1px solid #ddd;'" 
                  @click="targetDetailFilterType = 'ikram'">× 0₺ İkramlar</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="filteredTargetDetailList.length === 0" class="p-5 text-center text-muted bg-white rounded sale-box-shadow my-auto">
          Kayıtlı uygun satış hareketi bulunamadı.
        </div>

        <div v-else class="table-responsive bg-white rounded sale-box-shadow table-scroll-container">
          <table class="table w-full custom-detail-table" style="width:100%; border-collapse:collapse;">
            <thead>
              <tr style="background:#f8f9fa; text-align:left; font-size:13px; color:#495057; position:sticky; top:0; z-index:2;">
                <th class="p-3" style="border-bottom:2px solid #dee2e6;">Fiş No</th>
                <th class="p-3" style="border-bottom:2px solid #dee2e6;">Tarih & Saat</th>
                <th class="p-3 text-center" style="border-bottom:2px solid #dee2e6;">Sipariş Türü</th>
                <th class="p-3" style="border-bottom:2px solid #dee2e6;">Personel</th>
                <th class="p-3" style="border-bottom:2px solid #dee2e6;">Ürün</th>
                <th class="p-3 text-center" style="border-bottom:2px solid #dee2e6;">Adet</th>
                <th class="p-3 text-right" style="border-bottom:2px solid #dee2e6;">Tutar</th>
                <th class="p-3 text-center" style="border-bottom:2px solid #dee2e6;">Hedef Durumu</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in paginatedTargetDetailList" :key="item.orderId + '-' + item.productName + '-' + item.billNo" style="border-bottom:1px solid #f1f3f5; font-size:13px;">
                <td class="p-3 font-mono bold" style="font-weight:700; color:#7367f0;">#{{ item.billNo }}</td>
                <td class="p-3 text-muted" style="font-size:12px;">{{ formatDate(item.orderDate) }}</td>
                <td class="p-3 text-center font-bold">
                  {{ getOrderSourceBadge(item).text }}
                </td>
                <td class="p-3 bold text-dark">{{ item.personalName || 'Kasa' }}</td>
                <td class="p-3 text-dark font-medium">{{ item.productName }}</td>
                <td class="p-3 text-center font-bold text-primary" style="font-weight:700; font-size:14px;">x{{ item.quantity }}</td>
                <td class="p-3 text-right font-bold text-dark">{{ $toCurrency(item.totalPrice) }}</td>
                <td class="p-3 text-center">
                  <span v-if="item.totalPrice > 0" class="badge p-1" style="background:#e8f8f0; color:#28c76f; padding:5px 10px; border-radius:6px; font-weight:600; font-size:11px;">
                    ✓ Hedefe Dahil
                  </span>
                  <span v-else class="badge p-1" style="background:#fceaea; color:#ea5455; padding:5px 10px; border-radius:6px; font-weight:600; font-size:11px;">
                    × 0₺ İkram (Harici)
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- SAYFALAMA BARI (PAGINATION) -->
        <div v-if="filteredTargetDetailList.length > 0" class="d-flex justify-content-between align-items-center mt-2 p-2 bg-white rounded sale-box-shadow" style="border-radius:12px; flex-shrink:0;">
          <div class="text-muted font-medium" style="font-size:13px;">
            Gösterilen: <b class="text-primary">{{ pageStartItemIndex }} - {{ pageEndItemIndex }}</b> / Toplam <b>{{ filteredTargetDetailList.length }}</b> Fiş Kaydı
          </div>
          <div class="d-flex align-items-center" style="gap:10px;">
            <button type="button" class="btn btn-sm btn-outline-primary px-3" :disabled="currentPage === 1" @click="currentPage--" style="border-radius:6px; font-weight:600; cursor:pointer;">
              ‹ Önceki
            </button>
            <span class="px-2 font-bold text-dark" style="font-size:13px;">
              Sayfa {{ currentPage }} / {{ totalPages }}
            </span>
            <button type="button" class="btn btn-sm btn-outline-primary px-3" :disabled="currentPage >= totalPages" @click="currentPage++" style="border-radius:6px; font-weight:600; cursor:pointer;">
              Sonraki ›
            </button>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-col id="targetSide" vs-type="flex" vs-sm="12" vs-lg="6">
      <vs-row vs-type="flex" vs-w="12">
        <vs-row id="targetOptions" vs-type="flex" vs-w="12" vs-align="center" class="px-4">
          <vs-col v-if="$isCenterBranch() ||$isRegionalCenterBranch()" vs-type="flex" vs-w="6.5" class="px-1">
            <v-select class="w-full targetBranchSelect weight-500" :clearable="false" placeholder="Şube Seçimi"
              itemid="id" label="name" v-model="tableOptions.branch" :options="branches" />
          </vs-col>
          <vs-col v-else vs-type="flex" class="px-1 w-auto" vs-align="center">
            <span class="text-dark weight-500 text-small">
              {{tableOptions.branch.name}}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" class="px-1">
            <v-select class="w-full targetMonthSelect weight-500" :clearable="false" itemid="id" label="name"
              v-model="tableOptions.month" :options="$months()" />
          </vs-col>
          <vs-col vs-type="flex" vs-w="2.5" class="px-1">
            <v-select class="w-full targetYearSelect weight-500" :clearable="false" itemid="id" label="name"
              v-model="tableOptions.year" :options="$years()" />
          </vs-col>
        </vs-row>
        <vs-row id="targetDetails" vs-type="flex" vs-w="12" class="mt-1" v-if="tableOptions.branch">
          <div class="w-full">
            <!-- Şube Hedefleri Kartı -->
            <div id="branchTargetsCard" class="bg-white modern-target-card mb-5 p-4" :class="{'newTargetLine' : newBranchTarget != null}">
              <div class="modern-card-header mb-4 pb-3">
                <div class="flex justify-between items-start" style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%;">
                  <div>
                    <h3 class="text-secondary text-base bold" style="display: flex; align-items: center; gap: 8px; font-size: 1.1rem; font-weight: 700; margin: 0;">
                      <vs-button type="gradient" color="success" radius size="small" icon-pack="pickicon" icon="icon-home" style="pointer-events: none; margin: 0; padding: 6px;" />
                      Şube Hedefleri
                    </h3>
                    <div class="w-full d-flex text-xsmall weight-500 text-dark mt-1" style="display: flex; align-items: center; font-size: 0.8rem; margin-top: 4px;">
                      <span class="d-flex text-secondary text-xsmall bold mr-1" style="font-weight: 700;">
                        {{tableOptions.month.name}}
                      </span>
                      Ayı,
                      <span class="d-flex text-secondary text-xsmall bold ml-1 mr-1" style="font-weight: 700; margin-left: 4px; margin-right: 4px;">
                        {{tableOptions.branch.name}}
                      </span>
                      Şubesi için
                      <span class="d-flex text-secondary text-xsmall bold ml-1 mr-1" style="font-weight: 700; margin-left: 4px; margin-right: 4px;">
                        {{branchTargets.length}}
                      </span>
                      hedef belirlendi.
                    </div>
                  </div>
                  <div class="text-right">
                    <span v-if="daysToExpire != 0 && daysToExpire != null" class="modern-badge bg-danger-light text-danger bold text-xsmaller" style="font-weight: 700; font-size: 0.75rem;">
                      ⏳ {{daysToExpire}} Gün Kaldı
                    </span>
                    <span v-if="daysToExpire == 0 && daysToExpire != null" class="modern-badge bg-danger-light text-danger bold text-xsmaller" style="font-weight: 700; font-size: 0.75rem;">
                      🚨 Gün Sonunda Bitiyor
                    </span>
                  </div>
                </div>
              </div>
              <div class="modern-card-body">
                <vs-row vs-type="flex" vs-w="12" id="branchTargetList">
                  <vs-row v-if="($isCenterBranch||$isRegionalCenterBranch())" vs-type="flex" vs-w="12" class="mb-2">
                    <span v-if="isPastDate" class="badge p-2 font-bold" style="background:#fff8ec; color:#ff9f43; border-radius:6px; font-size:12px;">
                      ⚠️ Geçmiş dönemler için hedef eklenemez
                    </span>
                    <transition v-else name="slide-fade">
                      <vs-col v-if="newBranchTarget == null && newTargetPermission" vs-type="flex" vs-w="1" class="pr-1" vs-align="center">
                        <vs-button size="large" @click="newBranchTarget = {}"
                          class="w-full" icon-pack="feather" icon="icon-plus" color="success" />
                      </vs-col>
                      <div v-else class="d-flex w-full">
                        <vs-col vs-type="flex" vs-w="2.5" class="pr-1">
                          <v-select class="w-full weight-500" :clearable="false" placeholder="Tür Seçiniz" itemid="id"
                            label="name" v-model="newBranchTarget.kind" :options="targetKinds" />
                        </vs-col>
                        <vs-col v-if="newBranchTarget.kind && newBranchTarget.kind.id == 1" vs-type="flex" vs-w="4.5"
                          class="px-1">
                          <v-select name="Ürün Seçimi" class="w-full weight-500" :clearable="false"
                            v-validate="'required'" placeholder="Ürün Seçimi" itemid="id" label="name"
                            v-model="newBranchTarget.product" :options="products" />
                        </vs-col>
                        <vs-col v-if="newBranchTarget.kind && newBranchTarget.kind.id == 3" vs-type="flex" vs-w="4.5"
                          class="px-1">
                          <v-select name="Kategori Seçimi" class="w-full weight-500" :clearable="false"
                            v-validate="'required'" placeholder="Kategori Seçimi" itemid="id" label="name"
                            v-model="newBranchTarget.category" :options="categories" />
                        </vs-col>
                        <vs-col v-if="newBranchTarget.kind != null" vs-type="flex" vs-w="3" class="px-1">
                          <vs-input name="Miktar" v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"
                            v-model="newBranchTarget.targetQuantity" class="w-full"
                            :placeholder="newBranchTarget.kind.id == 2 ? 'Tutar Giriniz' : 'Miktar Giriniz'" />
                        </vs-col>
                        <vs-col vs-type="flex" vs-w="1" class="px-1" vs-align="center" vs-justify="center">
                          <vs-button @click="newBranchTarget = null" icon-pack="feather" icon="icon-x" radius
                            color="danger" size="small" />
                        </vs-col>
                        <vs-col vs-type="flex" vs-w="1" class="px-1" vs-align="center" vs-justify="center">
                          <vs-button @click="submitNewTarget"
                            :disabled="newBranchTarget.targetQuantity == null || errors.has('Miktar') || (newBranchTarget.kind && newBranchTarget.kind.id == 1 && newBranchTarget.product == null) || (newBranchTarget.kind && newBranchTarget.kind.id == 3 && newBranchTarget.category == null)"
                            icon-pack="feather" icon="icon-check" radius color="success" size="small" />
                        </vs-col>
                      </div>
                    </transition>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" class="branchTargetRow mb-2 cursor-pointer" vs-justify="center" vs-align="center"
                    v-for="(target,index) in branchTargets" :key="index" @click.native="openTargetDetails(target)" title="Tıklayarak Sipariş Kanıt Detayını İnceleyin">
                    <vs-col vs-type="flex" vs-w="1" vs-align="center" class="pr-1">
                      <vs-button v-if="target.kind == 1" size="large" class="w-full targetTypeAvatar"
                        type="filled" color="rgb(60, 232, 196)" icon-pack="pickicon" icon="icon-products" />
                      <vs-button v-if="target.kind == 2" size="large" class="w-full targetTypeAvatar" type="filled"
                        color="rgb(142, 224, 232)" icon-pack="pickicon" icon="icon-rich" />
                      <vs-button v-if="target.kind == 3" size="large" class="w-full targetTypeAvatar" type="filled"
                        color="rgb(255, 159, 67)" icon-pack="feather" icon="icon-layers" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="3" vs-align="center" class="px-1">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <span v-if="target.kind == 1" class="text-dark text-xsmall bold">
                            Ürün Hedefi
                          </span>
                          <span v-if="target.kind == 2" class="text-dark text-xsmall bold">
                            Ciro Hedefi
                          </span>
                          <span v-if="target.kind == 3" class="text-dark text-xsmall bold">
                            Kategori Hedefi
                          </span>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <span v-if="target.kind == 1" class="text-secondary text-xsmaller weight-600">
                            {{target.targetQuantity + ' Adet ' + (target.product ? target.product.name : '')}}
                          </span>
                          <span v-if="target.kind == 2" class="text-secondary text-xsmaller weight-600">
                            {{$toCurrency(target.targetQuantity)}}
                          </span>
                          <span v-if="target.kind == 3" class="text-secondary text-xsmaller weight-600">
                            {{target.targetQuantity + ' Adet ' + (target.category ? target.category.name : '')}}
                          </span>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="7" vs-align="center" class="px-1">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                           <vs-progress :percent="target.targetQuantity > 0 ? (target.targetProcess * 100 / target.targetQuantity) : 0"
                             :color="target.kind == 3 ? 'rgb(255, 159, 67)' : (target.kind == 2 ? 'rgb(142, 224, 232)' : 'rgb(60, 232, 196)')">
                           </vs-progress>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-col v-if="target.status != 2 && target.status != 'Finished'" vs-type="flex" vs-w="6" vs-justify="flex-start">
                            <span v-if="target.kind == 1 || target.kind == 3" class="text-secondary bold text-xsmall">
                              {{target.targetProcess + ' Adet'}}
                            </span>
                            <span v-if="target.kind == 2" class="text-secondary bold text-xsmall">
                              {{$toCurrency(target.targetProcess)}}
                            </span>
                          </vs-col>
                          <vs-col v-if="target.status != 2 && target.status != 'Finished'" vs-type="flex" vs-w="6" vs-justify="flex-end">
                            <span v-if="target.kind == 1 || target.kind == 3" class="text-secondary bold text-xsmall">
                              {{target.targetQuantity + ' Adet'}}
                            </span>
                            <span v-if="target.kind == 2" class="text-secondary bold text-xsmall">
                              {{$toCurrency(target.targetQuantity)}}
                            </span>
                          </vs-col>
                          <vs-col v-if="target.status == 2 || target.status == 'Finished'" vs-type="flex" vs-w="12" vs-justify="center">
                            <span class="w-full text-center text-success bold text-smaller">
                              Hedefe Ulaşıldı !
                            </span>
                          </vs-col>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="1" vs-align="center" vs-justify="center" class="pl-1 mb-3">
                      <feather-icon icon="SearchIcon" svgClasses="w-4 h-4 mr-2 hover:text-primary stroke-current cursor-pointer"
                        title="Sipariş Kanıt Dökümünü Gör" @click.native.stop="openTargetDetails(target)" />
                      <feather-icon icon="TrashIcon" svgClasses="w-4 h-4 hover:text-danger stroke-current cursor-pointer"
                        @click.stop="deletedId = target.id;deletePopupActive = true;" />
                    </vs-col>
                  </vs-row>
                </vs-row>
              </div>
            </div>

            <!-- Personel Hedefleri Kartı -->
            <div id="personalTargetsCard" class="bg-white modern-target-card mb-5 p-4" :class="{'newTargetLine' : newPersonalTarget != null}">
              <div class="modern-card-header mb-4 pb-3">
                <div class="flex justify-between items-start" style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%;">
                  <div>
                    <h3 class="text-secondary text-base bold" style="display: flex; align-items: center; gap: 8px; font-size: 1.1rem; font-weight: 700; margin: 0;">
                      <vs-button type="gradient" color="primary" radius size="small" icon-pack="pickicon" icon="icon-user" style="pointer-events: none; margin: 0; padding: 6px;" />
                      Personel Hedefleri
                    </h3>
                    <div class="w-full d-flex text-xsmall weight-500 text-dark mt-1" style="display: flex; align-items: center; font-size: 0.8rem; margin-top: 4px;">
                      <span class="d-flex text-secondary text-xsmall bold mr-1" style="font-weight: 700;">
                        {{tableOptions.month.name}}
                      </span>
                      Ayı,
                      <span class="d-flex text-secondary text-xsmall bold ml-1 mr-1" style="font-weight: 700; margin-left: 4px; margin-right: 4px;">
                        {{tableOptions.branch.name}}
                      </span>
                      Personelleri için
                      <span class="d-flex text-secondary text-xsmall bold ml-1 mr-1" style="font-weight: 700; margin-left: 4px; margin-right: 4px;">
                        {{personalTargets.length}}
                      </span>
                      hedef belirlendi.
                    </div>
                  </div>
                  <div class="text-right">
                    <span v-if="daysToExpire != 0 && daysToExpire != null" class="modern-badge bg-danger-light text-danger bold text-xsmaller" style="font-weight: 700; font-size: 0.75rem;">
                      ⏳ {{daysToExpire}} Gün Kaldı
                    </span>
                    <span v-if="daysToExpire == 0 && daysToExpire != null" class="modern-badge bg-danger-light text-danger bold text-xsmaller" style="font-weight: 700; font-size: 0.75rem;">
                      🚨 Gün Sonunda Bitiyor
                    </span>
                  </div>
                </div>
              </div>
              <div class="modern-card-body">
                <vs-row v-if="($isCenterBranch||$isRegionalCenterBranch())" vs-type="flex" vs-w="12" class="mb-2">
                  <span v-if="isPastDate" class="badge p-2 font-bold" style="background:#fff8ec; color:#ff9f43; border-radius:6px; font-size:12px;">
                    ⚠️ Geçmiş dönemler için hedef eklenemez
                  </span>
                  <transition v-else name="slide-fade">
                    <vs-col v-if="newPersonalTarget == null && newTargetPermission" vs-type="flex" vs-w="1" class="pr-1" vs-align="center">
                      <vs-button @click="newPersonalTarget = {}" icon-pack="feather"
                        icon="icon-plus" class="w-full" size="large" color="success" />
                    </vs-col>
                    <div v-else class="d-flex w-full">
                      <vs-col vs-type="flex" vs-w="2.5" class="pr-1">
                        <v-select class="w-full weight-500" :clearable="false" placeholder="Tür Seçiniz" itemid="id"
                          label="name" v-model="newPersonalTarget.kind" :options="targetKinds" />
                      </vs-col>
                      <vs-col v-if="newPersonalTarget.kind && newPersonalTarget.kind.id == 1" vs-type="flex" vs-w="4.5"
                        class="px-1">
                        <v-select name="Ürün Seçimi" class="w-full targetBranchSelect weight-500" :clearable="false"
                          v-validate="'required'" placeholder="Ürün Seçimi" itemid="id" label="name"
                          v-model="newPersonalTarget.product" :options="products" />
                      </vs-col>
                      <vs-col v-if="newPersonalTarget.kind && newPersonalTarget.kind.id == 3" vs-type="flex" vs-w="4.5"
                        class="px-1">
                        <v-select name="Kategori Seçimi" class="w-full targetBranchSelect weight-500" :clearable="false"
                          v-validate="'required'" placeholder="Kategori Seçimi" itemid="id" label="name"
                          v-model="newPersonalTarget.category" :options="categories" />
                      </vs-col>
                      <vs-col v-if="newPersonalTarget.kind != null" vs-type="flex" vs-w="3" class="px-1">
                        <vs-input name="Miktar" v-validate="{regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"
                          v-model="newPersonalTarget.targetQuantity" class="w-full"
                          :placeholder="newPersonalTarget.kind.id == 2 ? 'Tutar Giriniz' : 'Miktar Giriniz'" />
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="1" class="px-1" vs-align="center" vs-justify="center">
                        <vs-button @click="newPersonalTarget = null" icon-pack="feather" icon="icon-x" color="danger"
                          size="small" />
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="1" class="px-1" vs-align="center" vs-justify="center">
                        <vs-button @click="submitNewTarget"
                          :disabled="newPersonalTarget.targetQuantity == null || errors.has('Miktar') || (newPersonalTarget.kind && newPersonalTarget.kind.id == 1 && newPersonalTarget.product == null) || (newPersonalTarget.kind && newPersonalTarget.kind.id == 3 && newPersonalTarget.category == null)"
                          icon-pack="feather" icon="icon-check" radius color="success" size="small" />
                      </vs-col>
                    </div>
                  </transition>
                </vs-row>
                <vs-row vs-type="flex" vs-w="12" id="personalTargetList">
                  <div @click="openTargetReviewer(target)" class="d-flex vs-row w-full personalTargetRow mb-2"
                    vs-justify="center" vs-align="center" v-for="(target,index) in personalTargets" :key="index">
                    <vs-col vs-type="flex" vs-w="1" vs-align="center" class="pr-1">
                      <vs-button v-if="target.kind == 1" size="large" class="w-full targetTypeAvatar"
                        type="filled" color="rgb(60, 232, 196)" icon-pack="pickicon" icon="icon-products" />
                      <vs-button v-if="target.kind == 2" size="large" class="w-full targetTypeAvatar" type="filled"
                        color="rgb(142, 224, 232)" icon-pack="pickicon" icon="icon-rich" />
                      <vs-button v-if="target.kind == 3" size="large" class="w-full targetTypeAvatar" type="filled"
                        color="rgb(255, 159, 67)" icon-pack="feather" icon="icon-layers" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="3" vs-align="center" class="px-1">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <span v-if="target.kind == 1" class="text-dark text-xsmall bold">
                            Ürün Hedefi
                          </span>
                          <span v-if="target.kind == 2" class="text-dark text-xsmall bold">
                            Ciro Hedefi
                          </span>
                          <span v-if="target.kind == 3" class="text-dark text-xsmall bold">
                            Kategori Hedefi
                          </span>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <span v-if="target.kind == 1" class="text-secondary text-xsmaller weight-600">
                            {{target.targetQuantity + ' Adet ' + (target.product ? target.product.name : '')}}
                          </span>
                          <span v-if="target.kind == 2" class="text-secondary text-xsmaller weight-600">
                            {{$toCurrency(target.targetQuantity)}}
                          </span>
                          <span v-if="target.kind == 3" class="text-secondary text-xsmaller weight-600">
                            {{target.targetQuantity + ' Adet ' + (target.category ? target.category.name : '')}}
                          </span>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="7" vs-align="center" class="px-1">
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-progress :percent="target.targetPersonals && target.targetPersonals.length > 0 ? (target.targetProcess * 100 / target.targetPersonals.length) : 0"
                            :color="target.kind == 3 ? 'rgb(255, 159, 67)' : (target.kind == 2 ? 'rgb(142, 224, 232)' : 'rgb(60, 232, 196)')">
                          </vs-progress>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-col v-if="target.status == 1 || target.status == 'InProgress'" vs-type="flex" vs-w="8" vs-justify="flex-start">
                            <span class="text-secondary bold text-xsmall">
                              {{target.targetProcess + ' Personel Tamamlamış'}}
                            </span>
                          </vs-col>
                          <vs-col v-if="target.status == 1 || target.status == 'InProgress'" vs-type="flex" vs-w="4" vs-justify="flex-end">
                            <span class="text-secondary bold text-xsmall">
                              {{target.targetPersonals.length + ' Personel'}}
                            </span>
                          </vs-col>
                          <vs-col v-if="target.status == 2 || target.status == 'Finished'" vs-type="flex" vs-w="12" vs-justify="flex-end">
                            <span class="w-full text-center text-success bold text-smaller">
                              Tüm Personel({{target.targetPersonals.length}}) Hedefe Ulaştı !
                            </span>
                          </vs-col>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="1" vs-align="center" vs-justify="center" class="pl-1 mb-3">
                      <feather-icon icon="SearchIcon" svgClasses="w-4 h-4 mr-2 hover:text-primary stroke-current cursor-pointer"
                        title="Personellerin Detay Dökümünü Gör" @click.native.stop="openTargetReviewer(target)" />
                      <feather-icon icon="TrashIcon" svgClasses="w-4 h-4 hover:text-danger stroke-current cursor-pointer"
                        @click.stop="deletedId = target.id;deletePopupActive = true;" />
                    </vs-col>
                  </div>
                </vs-row>
              </div>
            </div>
          </div>
        </vs-row>
      </vs-row>
    </vs-col>
    <vs-col id="targetReportSide" vs-type="flex" vs-sm="12" vs-lg="6"
      v-if="tableOptions.branch != null">
      <vs-row vs-type="block" vs-w="12" class="pl-3">
        <vs-row id="reportOptions" vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
          <vs-col vs-type="flex" vs-w="6.5" class="px-1" vs-align="center" vs-justify="flex-start">
            <span class="text-secondary text-medium-small mt-1 weight-600">
              {{reportTableOptions.branch.name}} Raporları
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" class="px-1">
            <v-select class="w-full targetMonthSelect weight-500" :clearable="false" itemid="id" label="name"
              v-model="reportTableOptions.month" :options="$months()" />
          </vs-col>
          <vs-col vs-type="flex" vs-w="2.5" class="px-1">
            <v-select class="w-full targetYearSelect weight-500" :clearable="false" itemid="id" label="name"
              v-model="reportTableOptions.year" :options="$years()" />
          </vs-col>
        </vs-row>
        
        <div v-if="reportLoading" class="w-full flex items-center justify-center p-12 mt-5 bg-white sale-box-shadow low-border-radius" style="min-height: 400px; display: flex; align-items: center; justify-content: center; flex-direction: column; width: 100%;">
          <div class="report-spinner mb-4"></div>
          <span class="text-secondary text-small weight-500">Raporlar yükleniyor, lütfen bekleyin...</span>
        </div>

        <template v-else-if="Object.keys(bestSellersReport).length > 0">
          <vs-row id="reportHeaderChips" vs-type="flex" vs-w="12" class="mt-4" vs-align="center"
            vs-justify="space-between">
          <vs-col vs-type="flex" vs-w="5.9" class="bg-white p-2 sale-box-shadow low-border-radius">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" class="w-auto" vs-align="center">
                <vs-button size="large" type="gradient" radius icon-pack="pickicon" icon="icon-rich"
                  color="rgb(142, 224, 232)" />
              </vs-col>
              <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-medium-small2 bold" style="color:rgb(142, 224, 232);">
                      {{$toCurrency(bestSellersReport.totalGiroByMonth)}}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary text-xsmall weight-600">
                      {{reportTableOptions.month.name + ' Ayı Ciro'}}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="5.9" class="bg-white p-2 sale-box-shadow low-border-radius">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" vs-w="w-auto" vs-align="center">
                <vs-button size="large" type="gradient" radius icon-pack="pickicon" icon="icon-products"
                  color="rgb(60, 232, 196)" />
              </vs-col>
              <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-medium-small2 bold" style="color:rgb(60, 232, 196);">
                      {{bestSellersReport.totalSelledProductQuantityByMonth + ' Adet'}}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary text-xsmall weight-600">
                      {{reportTableOptions.month.name + ' Ayı Satış Sayısı'}}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row id="bestSellerProducts" vs-type="flex" vs-w="12"
          class="mt-2 bg-white sale-box-shadow low-border-radius">
          <vs-row vs-type="flex" vs-w="12" vs-justify="flex-start" vs-align="center" class="pt-4 pb-1 px-4">
            <span class="text-smaller text-secondary bold">
              En Çok Satılan Ürünler
            </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" id="bestSellerProductList" class="py-1">
            <vs-row class="bestSellerProduct py-2 cursor-pointer" style="transition: all 0.2s;" vs-type="flex" vs-w="12" vs-align="center"
              v-for="(product,index) in bestSellersReport.bestSellerProducts" :key="index"
              @click.native="openReportItemDetails(product, 'product')" title="Tıklayarak Bu Ürünün Satış Detaylarını ve Fiş Dökümünü İnceleyin">
              <vs-col vs-type="flex" vs-w="0.5" class="mr-2" vs-justify="flex-end" vs-align="center">
                <span class="text-primary bold text-xsmall">
                  {{index+1}}.
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="4.5" vs-align="center">
                <span class="text-dark bold text-xsmall">
                  {{product.product.name}}
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="3" vs-justify="center" vs-align="center">
                <span class="text-secondary bold text-xsmall">
                  {{$toCurrency(product.amount)}}
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="3" vs-justify="flex-end" vs-align="center" class="pr-2">
                <span class="text-primary bold text-xsmall mr-2">
                  {{product.quantity}} Adet
                </span>
                <feather-icon icon="SearchIcon" svgClasses="w-4 h-4 text-primary stroke-current cursor-pointer" @click.native.stop="openReportItemDetails(product, 'product')" />
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-row>
        <vs-row id="bestSellerPersonals" vs-type="flex" vs-w="12"
          class="my-2 bg-white sale-box-shadow low-border-radius">
          <vs-row vs-type="flex" vs-w="12" vs-justify="flex-start" vs-align="center" class="pt-4 pb-1 px-4">
            <span class="text-smaller text-secondary bold">
              En Çok Satan Personeller
            </span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" id="bestSellerPersonalList" class="py-1">
            <vs-row class="bestSellerPersonal py-1 cursor-pointer" style="transition: all 0.2s;" vs-type="flex" vs-w="12" vs-align="center"
              v-for="(personal,index) in bestSellersReport.bestSellerPersonals" :key="index"
              @click.native="openReportItemDetails(personal, 'personal')" title="Tıklayarak Bu Personelin Satış Detaylarını ve Fiş Dökümünü İnceleyin">
              <vs-col vs-type="flex" vs-w="0.5" class="mr-2" vs-justify="flex-end" vs-align="center">
                <span class="text-primary bold text-xsmall">
                  {{index+1}}.
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="1.2" vs-align="center" vs-justify="flex-start" style="padding-right: 8px;">
                <div class="vs-avatar" style="width: 38px; height: 38px; border-radius: 50%; overflow: hidden; display: flex; align-items: center; justify-content: center; background-color: #f1f2f5; border: 1px solid rgba(0,0,0,0.05);">
                  <img v-if="personal.personal && personal.personal.image && !personal.personal.imageError" 
                       :src="getAvatar(personal.personal.image)" 
                       @error="$set(personal.personal, 'imageError', true)" 
                       style="width: 100%; height: 100%; object-fit: cover;" />
                  <feather-icon v-else icon="UserIcon" svgClasses="w-5 h-5 text-secondary stroke-current" />
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-w="3.5" vs-align="center">
                <span class="text-dark bold text-xsmall">
                  {{personal.personal.name}}
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="3" vs-justify="center" vs-align="center">
                <span class="text-secondary bold text-xsmall">
                  {{$toCurrency(personal.amount)}}
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="3" vs-justify="flex-end" vs-align="center" class="pr-2">
                <span class="text-primary bold text-xsmall mr-2">
                  {{personal.quantity}} Adet
                </span>
                <feather-icon icon="SearchIcon" svgClasses="w-4 h-4 text-primary stroke-current cursor-pointer" @click.native.stop="openReportItemDetails(personal, 'personal')" />
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-row>
      </template>

        <div v-else class="w-full flex items-center justify-center p-12 mt-5 bg-white sale-box-shadow low-border-radius" style="min-height: 400px; display: flex; align-items: center; justify-content: center; flex-direction: column; width: 100%;">
          <feather-icon icon="InboxIcon" svgClasses="w-12 h-12 text-warning stroke-current mb-4" />
          <span class="text-secondary text-small weight-500">Seçilen döneme ait satış raporu bulunamadı.</span>
        </div>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
  import {
    filterProductNameList
  } from "@/api/Filter.js";
  import {
    getBestSellerProductAndPersonal
  } from "@/api/Reports.js";
  import TargetReviewer from "./TargetReviewer.vue";
  import {
    createTarget,
    deleteTarget,
    getTargetList,
    getTargetListForDealer,
    getTargetDetails
  } from "@/api/Target";
  import {
    getBranchNameList
  } from "@/api/User";
  import {
    getCategoryNameList
  } from "@/api/ProductCategory";
  import {isGranted} from "@/utils/auth";
  export default {
    components: {
      TargetReviewer
    },
    data() {
      return {
        deletePopupActive: false,
        deletedId: null,
        newBranchTarget: null,
        newPersonalTarget: null,
        targetDetailPopupActive: false,
        targetDetailLoading: false,
        targetDetailTitle: '',
        targetDetailList: [],
        currentPage: 1,
        pageSize: 100,
        allMonthOrderDetails: [],
        targetDetailSearchText: '',
        targetDetailFilterType: 'all',
        targetDetailOrderSourceType: 'Tüm Türler',
        targetKinds: [{
            id: 1,
            name: "Ürün",
            origin: "Product"
          },
          {
            id: 2,
            name: "Ciro",
            origin: "Giro"
          },
          {
            id: 3,
            name: "Kategori",
            origin: "Category"
          }
        ],
        products: [],
        categories: [],
        bestSellersReport: {},
        reportLoading: false,
        reportTableOptions: {},
        daysToExpire: null,
        selectedTarget: {},
        tableOptions: {},
        targets: [],
        branches: [],
        isInitialLoad: true,
      }
    },
    methods: {
      submitNewTarget: async function () {
        if (this.isPastDate) {
          this.$vs.notify({
            color: "warning",
            title: "Uyarı",
            text: "Geçmiş dönemler için hedef eklenemez!"
          });
          return;
        }
        let checker;
        checker = await this.$validator.validateAll('form-1');
        if (!checker || this.tableOptions.branch == null || (this.newBranchTarget == {} && this.newPersonalTarget ==
            {})) return;
        let obj = null;
        if (this.newPersonalTarget != null && this.newPersonalTarget != {}) {
          obj = {
            type: 2,
            targetQuantity: parseFloat(this.newPersonalTarget.targetQuantity),
            branch: this.tableOptions.branch,
            kind: this.newPersonalTarget.kind.id,
            product: this.newPersonalTarget.kind.id == 1 ? this.newPersonalTarget.product : null,
            category: this.newPersonalTarget.kind.id == 3 ? this.newPersonalTarget.category : null,
            month: this.tableOptions.month.id,
            year: parseInt(this.tableOptions.year)
          };
        } else if (this.newBranchTarget != null && this.newBranchTarget != {}) {
          obj = {
            type: 1,
            targetQuantity: parseFloat(this.newBranchTarget.targetQuantity),
            branch: this.tableOptions.branch,
            kind: this.newBranchTarget.kind.id,
            product: this.newBranchTarget.kind.id == 1 ? this.newBranchTarget.product : null,
            category: this.newBranchTarget.kind.id == 3 ? this.newBranchTarget.category : null,
            month: this.tableOptions.month.id,
            year: parseInt(this.tableOptions.year)
          };
        }
        /*if(this.newBranchTarget)
        this.newBranchTarget.targetQuantity = this.newBranchTarget.targetQuantity ? parseFloat(this.newBranchTarget.targetQuantity) : 0;
        if(this.newPersonalTarget)
        this.newPersonalTarget.targetQuantity = this.newPersonalTarget.targetQuantity ? parseFloat(this.newPersonalTarget.targetQuantity) : 0;
        */
        createTarget(obj).then(res => {
          if (res && res.status == 200) {
            this.targets.unshift(res.data);
            this.newPersonalTarget = null;
            this.newBranchTarget = null;
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Yeni Hedef Başarıyla Eklendi !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Yeni Hedef Eklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      escape() {
        if (this.deletePopupActive == true) {
          this.deletePopupActive = false;
          this.deletedId = null
        }
      },
      getAvatar(image) {
        if (image == null) return this.$nullImage;
        else return this.$baseUrl + '/' + image;
      },
      openTargetReviewer(target) {
        this.selectedTarget = target;
        this.$refs.targetReviewer.isActive = true;
      },
      deleteTarget(id) {
        deleteTarget(id).then(res => {
          if (res && res.status == 200) {
            let index = this.targets.findIndex(x => x.id == id);
            this.targets.splice(index, 1);
            this.deletedId = null;
            this.deletePopupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Hedef Başarıyla Silindi !"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hedef Silinemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        })
      },
      fetchMonthOrderDetails() {
        let branchId = this.tableOptions.branch ? (typeof this.tableOptions.branch === 'object' ? this.tableOptions.branch.id : this.tableOptions.branch) : null;
        let month = this.tableOptions.month ? (typeof this.tableOptions.month === 'object' ? this.tableOptions.month.id : this.tableOptions.month) : null;
        let year = this.tableOptions.year ? parseInt(this.tableOptions.year) : 2026;

        if (!branchId || !month) return;
        this.allMonthOrderDetails = [];
        getTargetDetails(0, null, null, branchId, month, year).then(res => {
          if (res && res.status === 200) {
            this.allMonthOrderDetails = res.data || [];
          }
        }).catch(() => {
          this.allMonthOrderDetails = [];
        });
      },
      getBestSellerProductAndPersonal: function () {
        if (!this.reportTableOptions.branch || !this.reportTableOptions.month) return Promise.resolve();
        this.reportLoading = true;
        this.bestSellersReport = {};
        this.fetchMonthOrderDetails();
        return getBestSellerProductAndPersonal(this.reportTableOptions).then(res => {
          if (res && res.status === 200) {
            this.bestSellersReport = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Şube Raporları Yüklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        }).finally(() => {
          this.reportLoading = false;
        });
      },
      getBranchNameList: function () {
        return getBranchNameList().then(res => {
          if (res && res.status === 200) {
            this.branches = res.data;
            if (this.branches && this.branches.length > 0 && (!this.tableOptions || !this.tableOptions.branch)) {
              let defaultBranch = null;
              if (this.$currentUser && this.$currentUser.branch) {
                const userBranchId = typeof this.$currentUser.branch === 'object' ? this.$currentUser.branch.id : this.$currentUser.branch;
                defaultBranch = this.branches.find(b => b.id === userBranchId);
              }
              if (!defaultBranch) {
                defaultBranch = this.branches[0];
              }
              this.tableOptions.branch = defaultBranch;
              this.reportTableOptions.branch = defaultBranch;
            }
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Şube Listesi Yüklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      getTargetList: function () {
        if (this.$isRegionalCenterBranch()) {
          return getTargetListForDealer(this.tableOptions).then(res => {
            if (res && res.status === 200) {
              this.targets = res.data;
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Hedefler Yüklenemedi !"
              });
            }
          }).catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: error
            });
          });
        } else {
          return getTargetList(this.tableOptions).then(res => {
            if (res && res.status === 200) {
              this.targets = res.data;
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Hedefler Yüklenemedi !"
              });
            }
          }).catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: error
            });
          });
        }
      },
      handleTableScroll(e) {
        const el = e.target;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 150) {
          if (this.displayLimit < this.filteredTargetDetailList.length) {
            this.displayLimit += 100;
          }
        }
      },
      openTargetDetails(target, personal = null) {
        if (target.kind == 1) {
          this.targetDetailTitle = target.product ? target.product.name + ' - Ürün Hedef Detayı' : 'Ürün Hedef Detayı';
        } else if (target.kind == 3) {
          this.targetDetailTitle = target.category ? target.category.name + ' - Kategori Hedef Detayı' : 'Kategori Hedef Detayı';
        } else {
          this.targetDetailTitle = 'Ciro Hedef Detayı';
        }
        if (personal && personal.user) {
          this.targetDetailTitle += ' - ' + personal.user.name;
        }

        this.targetDetailPopupActive = true;
        this.targetDetailSearchText = '';
        this.targetDetailFilterType = 'all';
        this.targetDetailOrderSourceType = 'Tüm Türler';
        this.targetDetailLoading = true;
        this.currentPage = 1;
        this.targetDetailList = [];

        const personalUserId = personal && personal.user ? personal.user.id : null;
        getTargetDetails(target.id, personalUserId).then(res => {
          if (res && res.status === 200) {
            this.targetDetailList = res.data || [];
          } else {
            this.targetDetailList = [];
          }
          this.targetDetailLoading = false;
        }).catch(() => {
          this.targetDetailList = [];
          this.targetDetailLoading = false;
        });
      },
      openReportItemDetails(item, type) {
        if (!item) return;

        let branchId = null;
        if (this.reportTableOptions && this.reportTableOptions.branch) {
          branchId = typeof this.reportTableOptions.branch === 'object' ? this.reportTableOptions.branch.id : this.reportTableOptions.branch;
        }
        if (!branchId && this.tableOptions && this.tableOptions.branch) {
          branchId = typeof this.tableOptions.branch === 'object' ? this.tableOptions.branch.id : this.tableOptions.branch;
        }
        if (!branchId && this.$currentUser && this.$currentUser.branch) {
          branchId = typeof this.$currentUser.branch === 'object' ? this.$currentUser.branch.id : this.$currentUser.branch;
        }

        let month = null;
        if (this.reportTableOptions && this.reportTableOptions.month) {
          month = typeof this.reportTableOptions.month === 'object' ? this.reportTableOptions.month.id : this.reportTableOptions.month;
        }
        if (!month && this.tableOptions && this.tableOptions.month) {
          month = typeof this.tableOptions.month === 'object' ? this.tableOptions.month.id : this.tableOptions.month;
        }

        let year = null;
        if (this.reportTableOptions && this.reportTableOptions.year) {
          year = parseInt(this.reportTableOptions.year);
        }
        if (!year && this.tableOptions && this.tableOptions.year) {
          year = parseInt(this.tableOptions.year);
        }

        let productId = null;
        let personalUserId = null;

        if (type === 'product') {
          if (item.product) productId = item.product.id || item.product.Id || item.product;
          else if (item.id) productId = item.id;
          this.targetDetailTitle = (item.product && item.product.name ? item.product.name : 'Ürün') + ' - Satış Detayı';
        } else if (type === 'personal') {
          if (item.personal) personalUserId = item.personal.id || item.personal.Id || item.personal;
          else if (item.id) personalUserId = item.id;
          this.targetDetailTitle = (item.personal && item.personal.name ? item.personal.name : 'Personel') + ' - Satış Detayı';
        }

        this.targetDetailPopupActive = true;
        this.targetDetailSearchText = '';
        this.targetDetailFilterType = 'all';
        this.targetDetailOrderSourceType = 'Tüm Türler';
        this.targetDetailLoading = true;
        this.currentPage = 1;
        this.targetDetailList = [];

        getTargetDetails(0, personalUserId, productId, branchId, month, year).then(res => {
          if (res && res.status === 200) {
            this.targetDetailList = res.data || [];
          } else {
            this.targetDetailList = [];
          }
          this.targetDetailLoading = false;
        }).catch(() => {
          this.targetDetailList = [];
          this.targetDetailLoading = false;
        });
      },
      formatDate(d) {
        if (!d) return '';
        const date = new Date(d);
        return date.toLocaleDateString('tr-TR') + ' ' + date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
      },
      getOrderSourceBadge(tr) {
        if (!tr) return { text: 'Şube', color: 'primary', icon: 'icon-monitor' };
        if (tr.isMobile || tr.IsMobile) {
          return { text: 'Mobil', color: 'success', icon: 'icon-smartphone' };
        }
        const source = tr.orderSource !== undefined ? tr.orderSource : tr.OrderSource;
        if (source === 2 || source === 'Getir') {
          return { text: 'Getir', color: 'warning', icon: 'icon-shopping-bag' };
        } else if (source === 3 || source === 'Yemeksepeti' || source === 'YemekSepeti') {
          return { text: 'Yemeksepeti', color: 'danger', icon: 'icon-shopping-bag' };
        } else if (source === 4 || source === 'TrendyolYemek') {
          return { text: 'Trendyol', color: 'dark', icon: 'icon-shopping-bag' };
        } else if (source === 1 || source === 'SelfService') {
          return { text: 'Şube', color: 'primary', icon: 'icon-monitor' };
        }
        return { text: 'Şube', color: 'primary', icon: 'icon-monitor' };
      }
    },
    computed: {
      isPastDate() {
        if (!this.tableOptions || !this.tableOptions.year || !this.tableOptions.month) return false;
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth() + 1;
        const selYear = parseInt(this.tableOptions.year);
        const selMonth = typeof this.tableOptions.month === 'object' ? this.tableOptions.month.id : parseInt(this.tableOptions.month);

        return selYear < currentYear || (selYear === currentYear && selMonth < currentMonth);
      },
      branchTargets() {
        return this.targets.filter(x => x.type == 1);
      },
      personalTargets() {
        return this.targets.filter(x => x.type == 2);
      },
      newTargetPermission(){
        return isGranted("target_create")
      },
      totalPages() {
        return Math.ceil(this.filteredTargetDetailList.length / this.pageSize) || 1;
      },
      paginatedTargetDetailList() {
        const start = (this.currentPage - 1) * this.pageSize;
        return this.filteredTargetDetailList.slice(start, start + this.pageSize);
      },
      pageStartItemIndex() {
        return this.filteredTargetDetailList.length === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1;
      },
      pageEndItemIndex() {
        return Math.min(this.currentPage * this.pageSize, this.filteredTargetDetailList.length);
      },
      filteredTargetDetailList() {
        if (!this.targetDetailList) return [];
        let list = this.targetDetailList;

        if (this.targetDetailFilterType === 'valid') {
          list = list.filter(x => x.totalPrice > 0);
        } else if (this.targetDetailFilterType === 'ikram') {
          list = list.filter(x => x.totalPrice === 0);
        }

        if (this.targetDetailOrderSourceType && this.targetDetailOrderSourceType !== 'Tüm Türler') {
          list = list.filter(x => {
            const badge = this.getOrderSourceBadge(x);
            return badge.text.toLowerCase() === this.targetDetailOrderSourceType.toLowerCase();
          });
        }

        if (this.targetDetailSearchText && this.targetDetailSearchText.trim() !== '') {
          const query = this.targetDetailSearchText.toLowerCase().trim();
          list = list.filter(x => 
            (x.billNo && x.billNo.toString().toLowerCase().includes(query)) ||
            (x.productName && x.productName.toLowerCase().includes(query)) ||
            (x.personalName && x.personalName.toLowerCase().includes(query))
          );
        }

        return list;
      },
      targetDetailTotalQty() {
        return this.filteredTargetDetailList.filter(x => x.totalPrice > 0).reduce((acc, curr) => acc + (curr.quantity || 0), 0);
      },
      targetDetailTotalAmount() {
        return this.filteredTargetDetailList.reduce((acc, curr) => acc + (curr.totalPrice || 0), 0);
      }
    },
    watch: {
      targetDetailSearchText() {
        this.currentPage = 1;
      },
      targetDetailFilterType() {
        this.currentPage = 1;
      },
      targetDetailOrderSourceType() {
        this.currentPage = 1;
      },
      tableOptions: {
        deep: true,
        handler(val) {
          if (this.isInitialLoad) return;
          if (val == null || val.branch == null) return;
          this.$vs.loading();
          this.getTargetList().finally(() => {
            this.$vs.loading.close();
          });
          var today = this.$now.date();
          var totalDays = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
          if (today.getMonth() + 1 > this.tableOptions.month.id) this.daysToExpire = null;
          else this.daysToExpire = totalDays - today.getDate();
          this.newBranchTarget = null;
          this.newPersonalTarget = null;
        }
      },
      'tableOptions.branch': {
        deep: true,
        handler() {
          this.reportTableOptions.branch = this.tableOptions.branch;
        }
      },
      reportTableOptions: {
        deep: true,
        handler(val) {
          if (this.isInitialLoad) return;
          if (val && val.branch && val.month) {
            this.getBestSellerProductAndPersonal();
          }
        }
      }
    },
    created: async function () {
      this.isInitialLoad = true;
      this.$vs.loading();
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 13) {
          if (this.deletePopupActive) this.deleteTarget(this.deletedId);
        }
      });
      const userBranch = (this.$currentUser && this.$currentUser.branch) ? (typeof this.$currentUser.branch === 'object' ? this.$currentUser.branch : null) : null;
      this.tableOptions = {
        year: this.$now.date().getFullYear().toString(),
        month: this.$months().find(x => x.id == (this.$now.date().getMonth() + 1)),
        branch: userBranch,
        product: null,
        personal: null
      };
      this.reportTableOptions = {
        year: this.$now.date().getFullYear().toString(),
        month: this.$months().find(x => x.id == (this.$now.date().getMonth() + 1)),
        branch: userBranch,
      };

      try {
        await this.getBranchNameList();
        this.products = await filterProductNameList();
        const catRes = await getCategoryNameList();
        if (catRes && catRes.data) {
          this.categories = catRes.data;
        }

        if (this.tableOptions.branch) {
          await this.getTargetList();
          this.getBestSellerProductAndPersonal();
        }
      } catch (err) {
        console.error("Initialization error:", err);
      } finally {
        this.$vs.loading.close();
        this.isInitialLoad = false;
      }

      var today = this.$now.date();
      var totalDays = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
      if (today.getMonth() + 1 < this.tableOptions.month.id) this.daysToExpire = null;
      else this.daysToExpire = totalDays - today.getDate();
    }
  }

</script>

<style>
  .modern-target-card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05) !important;
    border: 1px solid rgba(0, 0, 0, 0.05);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .modern-target-card:hover {
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08) !important;
    transform: translateY(-2px);
  }
  .modern-card-header {
    border-bottom: 1px dashed rgba(0, 0, 0, 0.08);
  }
  .modern-badge {
    padding: 6px 12px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
  }
  .bg-danger-light {
    background-color: rgba(234, 84, 85, 0.1) !important;
  }

  .report-spinner {
    width: 50px;
    height: 50px;
    border: 5px solid rgba(0, 0, 0, 0.1);
    border-top-color: rgb(142, 224, 232);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  @media only screen and (max-height: 900px) {
    #targetsPage{
      overflow-y: auto!important;
    }
    #targetOptions .vs__dropdown-menu,
    #reportOptions .vs__dropdown-menu {
      max-height: 35vh !important;
    }

    #targetsPage,
    #personalTargets,
    #branchTargets,
    #branchTargets .con-content--item,
    #personalTargets .con-content--item,
    #bestSellerPersonals,
    #bestSellerProducts {
      max-height: unset;
    }
  }
  #reportOptions span{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #targetReportSide {
    border-left: 1px solid #00000030;
  }

  #targetOptions .vs__selected {
    color: rgba(var(--vs-primary), 1) !important;
  }

  #reportOptions .vs__selected {
    color: rgba(var(--vs-dark), 1) !important;
  }

  #reportOptions {
    height: 36.8px;
  }

  #targetOptions .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    width: 100% !important;
    min-width: unset !important;
  }

  #reportOptions .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    width: 100% !important;
    min-width: unset !important;
  }

  #targetOptions .vs__dropdown-toggle {
    border: none !important;
    border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
    border-radius: 0;
    padding: 0 !important;
  }

  #reportOptions .vs__dropdown-toggle {
    border: none !important;
    border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
    border-radius: 0;
    padding: 0 !important;
  }

  #targetDetails .vs-collapse .vs-collapse-item--header i {
    font-size: 2.25rem;
  }

  .targetTypeAvatar i {
    text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3) !important;
    color: #000000;
  }

  .personalTargetRow:hover {
    background-color: #00000010;
  }

  .branchTargetRow:hover {
    background-color: #00000010;
  }

  #reportHeaderChips button {
    border-width: 2px !important;
  }

  #reportHeaderChips i {
    font-weight: bold;
  }

  #reportHeaderChips {
    height: 65px;
  }

  #targetsPage {
    height: calc(100vh - 100px);
    overflow-y: auto !important;
  }

  .newTargetLine .con-content--item{
    min-height: 21vh!important;
  }
  .newTargetLine .vs-collapse-item--content{
    min-height: 21vh!important;
  }

  #personalTargets,
  #branchTargets {
    max-height: calc(50vh - 80px);
  }

  #branchTargets .con-content--item,
  #personalTargets .con-content--item {
    max-height: calc(50vh - 170px);
    overflow: auto;
  }

  #targetsPage .vs__selected-options {
    flex-wrap: nowrap !important;
    white-space: nowrap!important;
    overflow: hidden!important;
  }

  #bestSellerProducts {
    max-height: calc(50vh - 138px);
    overflow: auto;
  }

  #bestSellerPersonals {
    max-height: calc(50vh - 104px);
    overflow: auto;
  }

  #targetDetails .vs__search {
    font-size: .75rem;
  }

  #targetDetails .vs__selected {
    font-size: .75rem;
  }

  #targetDetails .vs-input--input {
    padding: .5rem !important;
    font-size: .75rem !important;
  }

  #targetDetails .vs-input--placeholder {
    padding: .4rem !important;
  }

  #branchTargetsCard {
    position: relative;
    z-index: 20;
  }

  #personalTargetsCard {
    position: relative;
    z-index: 10;
  }

  #targetDetails .v-select.vs--open {
    position: relative;
    z-index: 99999 !important;
  }

  #targetDetails .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    width: 100% !important;
    min-width: unset !important;
    font-size: .8rem !important;
    z-index: 999999 !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
    background: #ffffff !important;
  }

  /* FULLSCREEN POPUP MODAL STYLING & PERFORMANCE */
  .target-details-popup .vs-popup {
    width: 96vw !important;
    max-width: 96vw !important;
    height: 94vh !important;
    max-height: 94vh !important;
    margin: 3vh auto !important;
    border-radius: 16px !important;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25) !important;
  }

  .target-details-popup .vs-popup--content {
    height: calc(94vh - 65px) !important;
    max-height: calc(94vh - 65px) !important;
    overflow-y: hidden !important;
    padding: 1rem 1.25rem !important;
    display: flex;
    flex-direction: column;
  }

  .target-details-popup .target-details-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .target-details-popup .table-scroll-container {
    flex: 1;
    overflow-y: auto;
    border-radius: 12px;
    contain: strict;
    will-change: scroll-position;
  }

  .target-details-popup .custom-detail-table tr {
    content-visibility: auto;
    contain-intrinsic-size: 45px;
  }

  .target-details-popup .custom-detail-table tr:hover {
    background-color: #f4f5f7 !important;
  }

</style>
